import React from "react";
import { useApiRoutes } from "../hooks/useApiRoutes";
import { useGlobalStore } from "../hooks/useGlobalStore";

export function GlobalApiContainer() {
  const { setGlobalState } = useGlobalStore();
  const { getSwafStatusApi } = useApiRoutes();

  React.useEffect(() => {
    (async () => {
      try {
        const swafConfig = await getSwafStatusApi.get();
        setGlobalState({ swafConfig });
      } catch (err) {
        console.log(err);
      }
    })();
  }, []);

  return <></>;
}
